import { useAppDispatch } from "../../../store/hooks/StoreHooks";
import { getJetliftComparisonData, setComparisonData1, setComparisonData2, setComparisonData3, setComparisonInput1, setComparisonInput2, setComparisonInput3 } from "../../../store/jetlift/comparison/ComparisonSlice";

const useJetliftComparisonFacade = () => {
    const dispatch = useAppDispatch();
    
    const updateComparisonData1 = (data: any) => {
        return dispatch(setComparisonData1(data));
    };

    const updateComparisonData2 = (data: any) => {
        return dispatch(setComparisonData2(data));
    };

    const updateComparisonData3 = (data: any) => {
        return dispatch(setComparisonData3(data));
    };
    const updateComparisonInput1 = (data: any) => {
        return dispatch(setComparisonInput1(data));
    };

    const updateComparisonInput2 = (data: any) => {
        return dispatch(setComparisonInput2(data));
    };

    const updateComparisonInput3 = (data: any) => {
        return dispatch(setComparisonInput3(data));
    };

    const loadJetliftComparisonData = () => {
        return dispatch(getJetliftComparisonData());
    };

    return {
        updateComparisonData1,
        updateComparisonData2,
        updateComparisonData3,
        updateComparisonInput1,
        updateComparisonInput2,
        updateComparisonInput3,
        loadJetliftComparisonData,
    };
};

export default useJetliftComparisonFacade;